import { Injectable } from '@angular/core';
import { ConfigurationSettingsConfig } from './configuration-settings-url.config';
import { HttpService } from '@app/@core/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationSettingsService {
  constructor(private httpService: HttpService) {
    //Intentional
  }

  getUserList(orgid) {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.User.getUserorgList + orgid);
  }
  saveConfigSettings(modal) {
    return this.httpService.post(ConfigurationSettingsConfig.EndPoint.ConfigSettings.saveConfig, modal);
  }
  getConfigList() {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.ConfigSettings.getConfigList);
  }
  getConfigById(id) {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.ConfigSettings.getConfigById + id);
  }
  deleteConfig(id) {
    return this.httpService.delete(ConfigurationSettingsConfig.EndPoint.ConfigSettings.deleteConfig + id);
  }
  updateConfig(id, modal) {
    return this.httpService.patch(ConfigurationSettingsConfig.EndPoint.ConfigSettings.updateConfig + id, modal);
  }
  getAllUserRole(id?: any) {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.role.getAllOrgRole.replace('{orgid}', String(id)));
  }
  getEmailTemplateNewList() {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.Email.emailtemplateList);
  }
  getAllOrganizations() {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.org.getOrganizations);
  }
  uploadKey(objparams) {
    return this.httpService.post(ConfigurationSettingsConfig.EndPoint.Attachments.UploadKey, objparams);
  }
  getAllDatetimeFormatList() {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.ConfigSettings.datetimeFomrat);
  }
  getConfigurationsByOrgId(id) {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.ConfigSettings.getConfigurationsByOrgId + id);
  }

  registrationInfo() {
    return this.httpService.get(ConfigurationSettingsConfig.EndPoint.ConfigSettings.registrationInfo);
  }
}
